import BubbleCommon, {
  keyOpinionsGetAdvancedGPT,
  overviewEmergingTips,
  overviewNegativeTips,
  overviewPositiveTips,
} from '@op/components/BubbleCommon';
import CardCommon from '@op/components/CardCommon';
import { arrayToSimpleObj } from '@op/utils';
import React, { useMemo, useState } from 'react';
import TopicKeyword from './TopicKeyword';
import GPT from './GPT';
import './index.scss';
import { formatTimeToShow } from '@op/utils/time';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import { Segment } from 'tea-component';
import { useIntl } from 'umi';

import UserGuideOverview from '@op/components/UserGuide/overview';
import { useFrontWebConfig } from '@op/hooks/useFrontWebConfig';
import ChannelLabel from '@op/components/ChannelLabel';

const filters = [
  { text: 'Total-2', value: 'total' },
  { text: 'Negative', value: 'negative', tipsMap: overviewNegativeTips },
  { text: 'Positive', value: 'positive', tipsMap: overviewPositiveTips },
  {
    text: 'Emerging',
    value: 'emerging',
    tipsMap: overviewEmergingTips,
  },
];
const tabObjMap = arrayToSimpleObj(filters);

export default function OpinionsSummary({
  filter,
  translateTopic,
  userInfo,
  gameInfo,
  wholeGameInfo,
  isFilterChanged,
  isHourlyRefresh
}: any) {
  // const [curFilter, setCurFilter] = useState('total');
  const [channelOption, setChannelOption] = useState('total');
  const [sentimentOption, setSentimentOption] = useState('total');
  const { formatMessage } = useIntl();

  const tabOptions = useMemo(() => {
    const list = [
      { text: formatMessage({ id: 'Total-2' }), value: 'total' },
      { text: formatMessage({ id: 'Negative' }), value: 'negative' },
      { text: formatMessage({ id: 'Positive' }), value: 'positive' },
    ];

    if (wholeGameInfo?.use_neutral) {
      list.push({ text: formatMessage({ id: 'Neutral' }), value: 'neutral' });
    }
    return list;
  }, [formatMessage, wholeGameInfo]);

  const key_opinions_tab = useFrontWebConfig({ keys: 'key_opinions_tab' });

  return (
    <div style={{ marginBottom: '20px' }}>
      <CardCommon
        className="dbo-card-opinions-summary"
        title={
          <div className="dbo-card-title-info">
            <div className="dbo-card-title-info-title">
              {formatMessage({ id: 'Hot Discussions' })}
            </div>
            <div className="dbo-card-title-info-desc" style={{ top: '2px' }}>
              ({formatTimeToShow(filter)})
            </div>
            <BubbleCommon
              placement="top"
              iconStyle={{ marginTop: 4, marginLeft: 5 }}
              tipsMap={keyOpinionsGetAdvancedGPT}
            ></BubbleCommon>
            {
              isHourlyRefresh === true && (
                <div className="dbo-card-title-info-desc" style={{ top: '2px' }}>
                  {formatMessage({ id: 'Hourly Data Refresh' })}
                </div>
              )
            }
          </div>
        }
      >
        <div className="dbo-opinions-gpt-segments">
          <Segment
            options={[
              { text: formatMessage({ id: 'Total-2' }), value: 'total' },
              {
                text:
                  key_opinions_tab === 'steam' ? (
                    <ChannelLabel
                      iconStyle={{ width: 16, height: 16 }}
                      channel_name="steam"
                    ></ChannelLabel>
                  ) : (
                    formatMessage({ id: 'Game Store' })
                  ),
                value: 'game_store',
              },
              {
                text: formatMessage({ id: 'Social Media' }),
                value: 'social',
              },
            ]}
            value={channelOption}
            onChange={(value) => {
              setChannelOption(value);
              buriedBtnPoint('KOOS_ChannelTypeTAB');
            }}
          />
          <Segment
            options={tabOptions}
            value={sentimentOption}
            onChange={(value) => {
              setSentimentOption(value);
              buriedBtnPoint('KOOS_SentimentTypeTAB');
            }}
          />
        </div>
        <GPT
          userInfo={userInfo}
          gameInfo={gameInfo}
          filter={filter}
          isSteam={key_opinions_tab === 'steam'}
          wholeGameInfo={wholeGameInfo}
          isFilterChanged={isFilterChanged}
          sentimentOption={sentimentOption}
          channelOption={channelOption}
        ></GPT>
        <UserGuideOverview></UserGuideOverview>
      </CardCommon>
      <CardCommon>
        <TopicKeyword
          filter={filter}
          translateTopic={translateTopic}
          curFilter={sentimentOption}
          channelOption={channelOption}
        ></TopicKeyword>
      </CardCommon>
    </div>
  );
}
